import { useEffect, useState } from 'react';
import { autoImgs, burnerImgs } from '../shared';
import { PageHeader, SectionCTA } from '../Layout';

const CATS = [
  { key: 'all',        label: 'All Work' },
  { key: 'automotive', label: 'Automotive Dies' },
  { key: 'burner',     label: 'Burner Manufacturing' },
];

export default function GalleryPage() {
  useEffect(() => {
    document.title = 'Gallery | Ratnam Techo Inc. – Our Work in Precision Engineering';
  }, []);

  const [active, setActive] = useState('all');

  const autoItems   = autoImgs.map((src, i) => ({ src, cat: 'automotive', alt: `Automotive die work ${i + 1}` }));
  const burnerItems = burnerImgs.map((src, i) => ({ src, cat: 'burner',   alt: `Burner manufacturing ${i + 1}` }));
  const all = [...autoItems, ...burnerItems];

  const shown = active === 'all' ? all : all.filter(img => img.cat === active);

  return (
    <>
      <PageHeader
        title="Our Work"
        highlight="Precision in Every Project"
        sub="Browse our portfolio of automotive dies, glass burner manufacturing, Wire EDM cutting, and custom fabrication."
        crumb="Gallery"
      />

      <section className="section gallery-section" style={{ paddingTop: 60 }}>
        <div className="section-inner">

          {/* Filter tabs */}
          <div className="gallery-filters">
            {CATS.map(c => (
              <button
                key={c.key}
                className={`gallery-filter-btn${active === c.key ? ' active' : ''}`}
                onClick={() => setActive(c.key)}
              >
                {c.label}
              </button>
            ))}
          </div>

          <div className="gallery-grid gallery-grid-full">
            {shown.map((img, i) => (
              <div
                className={`gallery-item${i % 5 === 0 ? ' gallery-item-wide' : ''}`}
                key={img.src + i}
              >
                <img src={img.src} alt={img.alt} loading="lazy" />
                <div className="gallery-overlay" />
              </div>
            ))}
          </div>

          <div className="gallery-count">
            Showing {shown.length} of {all.length} projects
          </div>
        </div>
      </section>

      <SectionCTA
        heading="Like What You See?"
        sub="Contact us to discuss your project. We deliver the same quality on every single job."
      />
    </>
  );
}
